module.exports = __webpack_public_path__ + "img/maintenance-key.9f047a1b.svg";